import VisibilityOff from "../../assets/svg/visibility-off.svg?react";
import Visibility from "../../assets/svg/visibility.svg?react";
import Repeat from "../../assets/svg/repeat.svg?react";
import VideoCamera from "../../assets/svg/video-camera.svg?react";
import Camera from "../../assets/svg/camera.svg?react";
import EllipseRight from "../../assets/svg/ellipse-right.svg?react";
import Circle from "../../assets/svg/circle.svg?react";
import LiveClassIcon from "../../assets/svg/live-class.svg?react";
import AssignmentsIcon from "../../assets/svg/assignments.svg?react";
import ArrowBackIcon from "../../assets/svg/arrow-back.svg?react";
import Menu from "../../assets/svg/menu.svg?react";
import UserProfileIcon from "../../assets/svg/user-profile.svg?react";
import BotanyPlant from "../../assets/svg/botany_plant.svg?react";
import Botany from "../../assets/svg/botany.svg?react";
import ChemFlask from "../../assets/svg/chem_flask.svg?react";
import PhyBulb from "../../assets/svg/phy_bulb.svg?react";
import IconVideoplay from "../../assets/svg/icon_videoplay.svg?react";
import Zoology from "../../assets/svg/zoology.svg?react";
import EngBoxes from "../../assets/svg/eng_boxes.svg?react";
import Match from "../../assets/svg/math.svg?react";
import Check from "../../assets/svg/check.svg?react";
import ThumbUp from "../../assets/svg/thumb-up.svg?react";
import ThumbDown from "../../assets/svg/thumb-down.svg?react";
import SelectedThumbUp from "../../assets/svg/selected-thumb-up.svg?react";
import SelectedThumbDown from "../../assets/svg/selected-thumb-down.svg?react";
import Report from "../../assets/svg/report.svg?react";
import RewatchVideo from "../../assets/svg/rewatch_video.svg?react";
import SessionsAttended from "../../assets/svg/sessions-attended.svg?react";
import ClockIcon from "../../assets/svg/clock-icon.svg?react";
import NotepadIcon from "../../assets/svg/notepad-icon.svg?react";
import PhysicsSubjectIcon from "../../assets/svg/physics-subject-icon.svg?react";
import calendarIcon from "../../assets/svg/calendar-icon.svg?react";
import calendar from "../../assets/svg/calendar.svg?react";
import FilterIcon from "../../assets/svg/filter-icon.svg?react";
import GradeIcon from "../../assets/svg/course-grade-icon.svg?react";
import CourseIcon from "../../assets/svg/course-icon.svg?react";
import ArrowForwardIcon from "../../assets/svg/arrow-forward.svg?react";
import NoDataIcon from "../../assets/svg/no-data-icon.svg?react";
import CloseIcon from "../../assets/svg/close-icon.svg?react";
import CloseButton from "../../assets/svg/close-button1.svg?react";
import LogoWhite from "../../assets/svg/logo-white.svg?react";
import ContainerLeftFilled from "../../assets/svg/container-left-filled.svg?react";
import ContainerRightFilled from "../../assets/svg/container-right-filled.svg?react";
import ArrowBack from "../../assets/svg/arrow-back.svg?react";
import CheckedIcon from "../../assets/svg/checked-icon.svg?react";
import IndeterminateIcon from "../../assets/svg/indeterminate-checked-icon.svg?react";
import Close from "../../assets/svg/close.svg?react";
import ArrowRight from "../../assets/svg/arrow-right.svg?react";
import AinaArrowCta from "../../assets/svg/aina-arrow-cta.svg?react";
import ArrowBackIos from "../../assets/svg/arrow-back-ios.svg?react";
import RadioButtonUnchecked from "../../assets/svg/radio-button-unchecked.svg?react";
import RadioButtonChecked from "../../assets/svg/radio-button-checked.svg?react";
import Checkbox from "../../assets/svg/checkbox.svg?react";
import CheckboxChecked from "../../assets/svg/checkbox-checked.svg?react";
import CheckboxMinus from "../../assets/svg/checkbox-minus.svg?react";
import PhoneIcon from "../../assets/svg/phone-icon.svg?react";
import LinkedInIcon from "../../assets/svg/linkedin.svg?react";
import EmailIcon from "../../assets/svg/email.svg?react";
import FacebookIcon from "../../assets/svg/facebook.svg?react";
import XIcon from "../../assets/svg/X.svg?react";
import PersonIcon from "../../assets/svg/person-icon.svg?react";
import StopCircleIcon from "../../assets/svg/stop-circle.svg?react";
import AdmissionIcon from "../../assets/svg/admission-icon.svg?react";
import ArrowForward from "../../assets/svg/arrow-forward.svg?react";
import ExpandMore from "../../assets/svg/expand_more.svg?react";
import KeyBoardArrowDown from "../../assets/svg/keyboard_arrow_down.svg?react";
import KeyBoardArrowUp from "../../assets/svg/keyboard_arrow_up.svg?react";
import Edit from "../../assets/svg/edit.svg?react";
import Sms from "../../assets/svg/sms.svg?react";
import Whatsapp from "../../assets/svg/whatsapp.svg?react";
import VisibilityOnIcon from "../../assets/svg/visibility-on.svg?react";
import Info from "../../assets/svg/info.svg?react";
import Home from "../../assets/svg/Home.svg?react";
import HomeIcon from "../../assets/svg/Home_Icon.svg?react";
import ILLogoIcon from "../../assets/svg/IL_Logo_icon.svg?react";
import ILLogoIconWhite from "../../assets/svg/IL_Logo_white.svg?react";
import live_Classes from "../../assets/svg/Live_Classes.svg?react";
import learn from "../../assets/svg/Learn.svg?react";
import tests from "../../assets/svg/Tests.svg?react";
import Doubts from "../../assets/svg/Doubts.svg?react";
import bookmarks from "../../assets/svg/bookmark.svg?react";
import BookmarkIconDoubts from "../../assets/svg/bookmark_border.svg?react";
import SelectedBookmark from "../../assets/svg/selected_bookmark.svg?react";
import Subscriptions from "../../assets/svg/subscriptions.svg?react";
import ReferEarn from "../../assets/svg/ReferEarn.svg?react";
import contact_us from "../../assets/svg/contact_us.svg?react";
import log_out from "../../assets/svg/log_out.svg?react";
import IlLogo from "../../assets/svg/il-logo.svg?react";
import IL_logo from "../../assets/svg/il_logo.svg?react";
import Meta from "../../assets/svg/meta.svg?react";
import Sca from "../../assets/svg/sca.svg?react";
import CopyIcon from "../../assets/svg/copy.svg?react";
import ShareIcon from "../../assets/svg/share-icon.svg?react";
import ShareNotFilledIcon from "../../assets/svg/share.svg?react";

import ChemistryClass from "../../assets/svg/liveclasses/chemistry_bg.svg?react";
import PhysicsClass from "../../assets/svg/liveclasses/physics_bg.svg?react";
import MathsClass from "../../assets/svg/liveclasses/maths_bg.svg?react";
import EnglishClass from "../../assets/svg/liveclasses/english_bg.svg?react";
import BotanyClass from "../../assets/svg/liveclasses/botany_bg.svg?react";
import BiologyClass from "../../assets/svg/liveclasses/biology_bg.svg?react";
import ZoologyClass from "../../assets/svg/liveclasses/zology_bg.svg?react";
import InfoIcon from "../../assets/svg/liveclasses/InfoIcon.svg?react";
import RewatchIcon from "../../assets/svg/liveclasses/rewatch.svg?react";
import TimeIcon from "../../assets/svg/liveclasses/time.svg?react";
import VectorIcon from "../../assets/svg/liveclasses/Vector.svg?react";
import SecondaryIcon from "../../assets/svg/liveclasses/default-teacher-icon.svg?react";
import FilterAltIcon from "../../assets/svg/liveclasses/filter_alt.svg?react";
import IcTrBack from "../../assets/svg/ic_tr_Back.svg?react";
import CircleIcon from "../../assets/svg/circle-icon.svg?react";
import ChemistrySubjectIcon from "../../assets/svg/chemistry-subject-icon.svg?react";
import MathSubjectIcon from "../../assets/svg/math-subject-icon.svg?react";
import ZoologySubjectIcon from "../../assets/svg/zoology-subject-icon.svg?react";
import BotanySubjectIcon from "../../assets/svg/botany-subject-icon.svg?react";
import EnglishSubjectIcon from "../../assets/svg/english-subject-icon.svg?react";
import BiologySubjectIcon from "../../assets/svg/biology-subject-icon.svg?react";
import IcBioSubIcon from "../../assets/svg/ic_bio_sub_Icon.svg?react";
import IcBotanySubIcon from "../../assets/svg/ic_botany_sub_icon.svg?react";
import IcChemSubIcon from "../../assets/svg/ic_chem_sub_Icon.svg?react";
import IcComputerScienceSubIcon from "../../assets/svg/ic_computer_science_sub_Icon.svg?react";
import IcCriticalThinkingSubIcon from "../../assets/svg/ic_critical_thinking_sub_Icon.svg?react";
import IcDefaultSubIcon from "../../assets/svg/ic_default_sub_icon.svg?react";
import IcEngSubIcon from "../../assets/svg/ic_eng_sub_Icon.svg?react";
import IcEnglishSubIcon from "../../assets/svg/ic_english_sub_Icon.svg?react";
import IcGkSubIcon from "../../assets/svg/ic_gk_sub_Icon.svg?react";
import IcHindiSubIcon from "../../assets/svg/ic_hindi_sub_Icon.svg?react";
import IcHistorySubIcon from "../../assets/svg/ic_history_sub_Icon.svg?react";
import IcLogicalSubIcon from "../../assets/svg/ic_logical_sub_Icon.svg?react";
import IcMathSubIcon from "../../assets/svg/ic_math_sub_Icon.svg?react";
import IcPhySubIcon from "../../assets/svg/ic_phy_sub_Icon.svg?react";
import IcProbleamSolvingSubIcon from "../../assets/svg/ic_probleam_solving_sub_Icon.svg?react";
import IcScienceSubIcon from "../../assets/svg/ic_science_sub_Icon.svg?react";
import IcSocalStudySubIcon from "../../assets/svg/ic_socal_study_sub_Icon.svg?react";
import IcSubjectBusiness from "../../assets/svg/ic_subject_business.svg?react";
import IcSubjectCommerce from "../../assets/svg/ic_subject_commerce.svg?react";
import IcSubjectComnomics from "../../assets/svg/ic_subject_comnomics.svg?react";
import IcSubjectCivicSub from "../../assets/svg/ic_subject_civic_sub.svg?react";
import IcSubjectGeographySub from "../../assets/svg/ic_subject_geography_sub.svg?react";
import IcSubjectState from "../../assets/svg/ic_subject_state.svg?react";
import IcVedicMatchSubIcon from "../../assets/svg/ic_vedic_match_sub_Icon.svg?react";
import IcZooSubIcon from "../../assets/svg/ic_zoo_sub_Icon.svg?react";
import Illustration from "../../assets/svg/liveclasses/Illustration.svg?react";
import IlLogo1 from "../../assets/svg/il-logo-1.svg?react";
import Ellipse995 from "../../assets/svg/ellipse995.svg?react";
import VisibilityDark from "../../assets/svg/visibility_dark.svg?react";
import Male from "../../assets/svg/male.svg?react";
import Female from "../../assets/svg/female.svg?react";
import Add from "../../assets/svg/add.svg?react";
import ResetPassword from "../../assets/svg/resetPass.svg?react";
import Redirect from "../../assets/svg/redirect.svg?react";
import CheckmarkIcon from "../../assets/svg/checkmark-icon.svg?react";
import HeaderMenu from "../../assets/svg/header-menu.svg?react";
import InfoGreen from "../../assets/svg/info_green.svg?react";
import ResumeLearningLeftArrow from "../../assets/svg/resume_left_arrow.svg?react";
import ResumeLearningVideoIcon from "../../assets/svg/resume_learning_video_icon.svg?react";
import ResumeLearningFlashcardIcon from "../../assets/svg/selflearn/resume_learning_flashcrad_icon.svg?react";
import ResumeLearningPracticeIcon from "../../assets/svg/selflearn/resumelearning_practice_icon.svg?react";
import Vector from "../../assets/svg/vector.svg?react";
import CircleBackBtn from "../../assets/svg/circlebackbtn.svg?react";
import Book from "../../assets/svg/book.svg?react";
import Clock from "../../assets/svg/clock.svg?react";
import ChatIcon from "../../assets/svg/chat-icon.svg?react";
import ExpandIcon from "../../assets/svg/expand-icon.svg?react";
import selflearnConfirmationIcon from "../../assets/svg/selflearn/Illustration.svg?react";
import winCup from "../../assets/svg/selflearn/win-cup.svg?react";
import trialExpired from "../../assets/svg/selflearn/trial-expired.svg?react";
import contentCopy from "../../assets/svg/selflearn/content_copy.svg?react";
import cardGiftcard from "../../assets/svg/selflearn/card_giftcard.svg?react";
import ArrowUp from "../../assets/svg/keyboard_arrow_down.svg?react";
import ArrowDown from "../../assets/svg/arrow_down.svg?react";
import WindowIcon from "../../assets/svg/Window_Icon.svg?react";
import MoreDotsIcon from "../../assets/svg/More_Dots_Icon.svg?react";
import LearnIcon from "../../assets/svg/Learn_Icon.svg?react";
import TestsIcon from "../../assets/svg/Tests_Icon.svg?react";
import DoubtsIcon from "../../assets/svg/Doubts_Icon.svg?react";
import BookmarksIcon from "../../assets/svg/Bookmarks_Icon.svg?react";
import SubscriptionsIcon from "../../assets/svg/Subscription_Icon.svg?react";
import ReferEarnIcon from "../../assets/svg/Refer_And_Earn_Icon.svg?react";
import ContactUsIcon from "../../assets/svg/Contact_Us_Icon.svg?react";
import LogOutIcon from "../../assets/svg/Logout_Icon.svg?react";
import LiveClassesIcon from "../../assets/svg/Live_class_Icon.svg?react";
import PeopleIcon from "../../assets/svg/People_Icon.svg?react";
import media from "../../assets/svg/media.svg?react";
import card from "../../assets/svg/card.svg?react";
import buttonTonal from "../../assets/svg/buttonTonal.svg?react";
import ArrRight from "../../assets/svg/ArrRight.svg?react";
import t1 from "../../assets/svg/t1.svg?react";
import content from "../../assets/svg/content.svg?react";
import eye from "../../assets/svg/eye.svg?react";

import RightArrowIcon from "../../assets/svg/right_arrow_icon.svg?react";
import BookmarkTestImg from "../../assets/svg/selflearn/bookmarkTestImg.svg?react";
import BookmarkCardImg from "../../assets/svg/selflearn/bookmarkCardImg.svg?react";
import BookmarkTopicSummaryImg from "../../assets/svg/selflearn/bookmarkTopicSummaryImg.svg?react";
import BookmarkNotFoundImg from "../../assets/svg/selflearn/bookmarkNotFoundImg.svg?react";
import BookmarkCheckedMinus from "../../assets/svg/selflearn/bookmark_checked_minus.svg?react";
import BookmarkCheck from "../../assets/svg/selflearn/bookmark_checked.svg?react";
import BookmarkUnchecked from "../../assets/svg/selflearn/bookmark_unchecked.svg?react";

import IL_CardLogo from "../../assets/svg/IL_CardLogo.svg?react";
import ZoomIn from "../../assets/svg/zoom-in.svg?react";
import ZoomOut from "../../assets/svg/zoom-out.svg?react";
import bookCover from "../../assets/svg/selflearn/book-cover.svg?react";
import chemistryMainIcon from "../../assets/svg/subjectIcon/chemistryMainIcon.svg?react";
import chemistryDecor1Icon from "../../assets/svg/subjectIcon/chemistryDecor1Icon.svg?react";
import chemistryDecor2Icon from "../../assets/svg/subjectIcon/chemistryDecor2Icon.svg?react";
import mathsMainIcon from "../../assets/svg/subjectIcon/mathMainIcon.svg?react";
import mathsDecor1Icon from "../../assets/svg/subjectIcon/mathDecorIcon1Icon.svg?react";
import mathsDecor2Icon from "../../assets/svg/subjectIcon/mathDecor2Icon.svg?react";
import physicsMainIcon from "../../assets/svg/subjectIcon/physicsMainIcon.svg?react";
import physicsDecor1Icon from "../../assets/svg/subjectIcon/physicsDecor1Icon.svg?react";
import physicsDecor2Icon from "../../assets/svg/subjectIcon/physicsDecor2Icon.svg?react";
import englishMainIcon from "../../assets/svg/subjectIcon/englishMainIcon.svg?react";
import englishDecor1Icon from "../../assets/svg/subjectIcon/englishDecor1Icon.svg?react";
import englishDecor2Icon from "../../assets/svg/subjectIcon/englishDecor2Icon.svg?react";
import zoologyMainIcon from "../../assets/svg/subjectIcon/zoologyMainIcon.svg?react";
import zoologyDecor1Icon from "../../assets/svg/subjectIcon/zoologyDecor1Icon.svg?react";
import zoologyDecor2Icon from "../../assets/svg/subjectIcon/zoologyDecor2Icon.svg?react";
import botanyMainIcon from "../../assets/svg/subjectIcon/botanyMainIcon.svg?react";
import botanyDecor1Icon from "../../assets/svg/subjectIcon/botanyDecor1Icon.svg?react";
import botanyDecor2Icon from "../../assets/svg/subjectIcon/botanyDecor2Icon.svg?react";
import biologyMainIcon from "../../assets/svg/subjectIcon/biologyMainIcon.svg?react";
import civicsMainIcon from "../../assets/svg/subjectIcon/civicsMainIcon.svg?react";
import commerceMainIcon from "../../assets/svg/subjectIcon/commerceMainIcon.svg?react";
import computerMainIcon from "../../assets/svg/subjectIcon/computerMainIcon.svg?react";
import criticalThinkingMainIcon from "../../assets/svg/subjectIcon/criticalThinkingMainIcon.svg?react";
import economicsMainIcon from "../../assets/svg/subjectIcon/economicsMainIcon.svg?react";
import businessMainIcon from "../../assets/svg/subjectIcon/businessMainIcon.svg?react";
import evsMainIcon from "../../assets/svg/subjectIcon/evsMainIcon.svg?react";
import geographyMainIcon from "../../assets/svg/subjectIcon/geographyMainIcon.svg?react";
import gkMainIcon from "../../assets/svg/subjectIcon/gkMainIcon.svg?react";
import hindiMainIcon from "../../assets/svg/subjectIcon/hindiMainIcon.svg?react";
import historyMainIcon from "../../assets/svg/subjectIcon/historyMainIcon.svg?react";
import logicalMainIcon from "../../assets/svg/subjectIcon/logicalMainIcon.svg?react";
import physicsMain2Icon from "../../assets/svg/subjectIcon/physicsMain2Icon.svg?react";
import problemSolvingMainIcon from "../../assets/svg/subjectIcon/problemSolvingMainIcon.svg?react";
import scienceMainIcon from "../../assets/svg/subjectIcon/scienceMainIcon.svg?react";
import socialMainIcon from "../../assets/svg/subjectIcon/socialMainIcon.svg?react";
import statsMainIcon from "../../assets/svg/subjectIcon/statsMainIcon.svg?react";
import vedicMatchMainIcon from "../../assets/svg/subjectIcon/vedicMatchMainIcon.svg?react";
import genericMainIcon from "../../assets/svg/subjectIcon/generic.svg?react";
import biologyFilledIcon from "../../assets/svg/subjectIcons-filled-small/biologyFilledIcon.svg?react";
import botanyFilledIcon from "../../assets/svg/subjectIcons-filled-small/botanyFilledIcon.svg?react";
import businessFilledIcon from "../../assets/svg/subjectIcons-filled-small/businessFilledIcon.svg?react";
import chemistryFilledIcon from "../../assets/svg/subjectIcons-filled-small/chemistryFilledIcon.svg?react";
import civicsFilledIcon from "../../assets/svg/subjectIcons-filled-small/civicsFilledIcon.svg?react";
import commerceFilledIcon from "../../assets/svg/subjectIcons-filled-small/commerceFilledIcon.svg?react";
import computerFilledIcon from "../../assets/svg/subjectIcons-filled-small/computerFilledIcon.svg?react";
import criticalThinkingFilledIcon from "../../assets/svg/subjectIcons-filled-small/criticalThinkingFilledIcon.svg?react";
import economicsFilledIcon from "../../assets/svg/subjectIcons-filled-small/economicsFilledIcon.svg?react";
import englishFilledIcon from "../../assets/svg/subjectIcons-filled-small/englishFilledIcon.svg?react";
import evsFilledIcon from "../../assets/svg/subjectIcons-filled-small/evsFilledIcon.svg?react";
import genericFilledIcon from "../../assets/svg/subjectIcons-filled-small/genericFilledIcon.svg?react";
import geographyFilledIcon from "../../assets/svg/subjectIcons-filled-small/geographyFilledIcon.svg?react";
import gkFilledIcon from "../../assets/svg/subjectIcons-filled-small/gkFilledIcon.svg?react";
import hindiFilledIcon from "../../assets/svg/subjectIcons-filled-small/hindiFilledIcon.svg?react";
import historyFilledIcon from "../../assets/svg/subjectIcons-filled-small/historyFilledIcon.svg?react";
import logicalFilledIcon from "../../assets/svg/subjectIcons-filled-small/logicalFilledIcon.svg?react";
import mathFilledIcon from "../../assets/svg/subjectIcons-filled-small/mathFilledIcon.svg?react";
import physicsFilledIcon from "../../assets/svg/subjectIcons-filled-small/physicsFilledIcon.svg?react";
import problemSolvingFilledIcon from "../../assets/svg/subjectIcons-filled-small/problemSolvingFilledIcon.svg?react";
import scienceFilledIcon from "../../assets/svg/subjectIcons-filled-small/scienceFilledIcon.svg?react";
import socialFilledIcon from "../../assets/svg/subjectIcons-filled-small/socialFilledIcon.svg?react";
import statsFilledIcon from "../../assets/svg/subjectIcons-filled-small/statsFilledIcon.svg?react";
import vedicMatchFilledIcon from "../../assets/svg/subjectIcons-filled-small/vedicMatchFilledIcon.svg?react";
import zoologyFilledIcon from "../../assets/svg/subjectIcons-filled-small/zoologyFilledIcon.svg?react";
import BlueWhiteDot from "../../assets/svg/blue-white-dot.svg?react";
import BlueVector from "../../assets/svg/blue-vector.svg?react";
import WhiteDot from "../../assets/svg/white-dot.svg?react";
import StudentWithLaptop from "../../assets/svg/student-using-laptop.svg?react";
import ShareFilledIcon from "../../assets/svg/share-filled.svg?react";
import OpenBookIcon from "../../assets/svg/open-book.svg?react";
import WhiteArrowDown from "../../assets/svg/arrow-down.svg?react";
import CyotArrow from "../../assets/svg/cyotarrow.svg?react";
import Trapezoid from "../../assets/svg/trapezoid.svg?react";
import TrapezoidOutline from "../../assets/svg/trapezoid-outline.svg?react";
import CurrTrapezoid from "../../assets/svg/current-trapezium.svg?react";
import Funnel from "../../assets/svg/funnel.svg?react";
import InfoColor from "../../assets/svg/info_color.svg?react";
import SCA_CardLogo from "../../assets/svg/sca_cardLogo.svg?react";
import editFilled from "../../assets/svg/edit_filled.svg?react";
import SubscriptionLockIcon from "../../assets/svg/subscriptionlock.svg?react";
import CouponGift from "../../assets/svg/card_giftcard.svg?react";
import IcArrowUp from "../../assets/svg/ic_arrow_up.svg?react";
import IcArrowDown from "../../assets/svg/ic_arrow_down.svg?react";
import ScrollUpShorts from "../../assets/svg/scroll_up.svg?react";
import ScrollDownShorts from "../../assets/svg/scroll_down.svg?react";
import ArrowBackShorts from "../../assets/svg/arrow_back.svg?react";
import Footprints from "../../assets/svg/footprints.svg?react";
import Toffee from "../../assets/svg/toffee.svg?react";
import Chemistry from "../../assets/svg/chemistry-test.svg?react";
import ArrowUpTest from "../../assets/svg/arrow_up_test.svg?react";
import ForwardArrow from "../../assets/svg/forward_arrow.svg?react";
import BackwardArrow from "../../assets/svg/backward_arrow.svg?react";
import About from "../../assets/svg/about.svg?react";
import Flag from "../../assets/svg/flag.svg?react";
import TextView from "../../assets/svg/text_snippet.svg?react";
import GridView from "../../assets/svg/grid_view.svg?react";
import videoIcon from "../../assets/svg/selflearn/videoIcon.svg?react";
import BackIcon from "../../assets/svg/back-button.svg?react";
import FullScreenIcon from "../../assets/svg/full-screen-icon.svg?react";
import FullScreenExitIcon from "../../assets/svg/full-screen-exit-icon.svg?react";
import CollapseArrow from "../../assets/svg/collapse-arrow-dark.svg?react";
import MarketingPageIcon from "../../assets/svg/marketing-page-logo.svg?react";
import SessionDetailsIcon from "../../assets/svg/session-details-icon.svg?react";
import ReportIssueIcon from "../../assets/svg/report-an-issue-icon.svg?react";
import ThreeDotIcon from "../../assets/svg/three-v-icon.svg?react";
import ReportIssueIconBlack from "../../assets/svg/report-an-issue-icon-black.svg?react";
import SessionDetailsIconBlack from "../../assets/svg/session-details-icon-black.svg?react";
import HomeFilled from "../../assets/svg/home-filled.svg?react";
import HomeOutline from "../../assets/svg/home-outlined.svg?react";
import PlayFilled from "../../assets/svg/play-filled.svg?react";
import PlayOutline from "../../assets/svg/play-outlined.svg?react";
import BookFilled from "../../assets/svg/book-filled.svg?react";
import BookOutline from "../../assets/svg/book-outlined.svg?react";
import TodoIcon from "../../assets/svg/todo-icon.svg?react";
import Timer from "../../assets/svg/Timer.svg?react";
import BookmarkFilled from "../../assets/svg/selflearn/bookmark-filled.svg?react";
import LockIcon from "../../assets/svg/selflearn/lock-icon.svg?react";
import InteractiveDefaultIcon from "../../assets/svg/selflearn/interactive-default.svg?react";
import InteractivePlayIcon from "../../assets/svg/selflearn/play-icon.svg?react";
import RedTriangleWithWhiteExclamation from "../../assets/svg/red-triangle-with-white-exclamation.svg?react";
import InteractiveIllustration from "../../assets/svg/selflearn/Interactive-Illustration.svg?react";
import LiveClassesCalender from "../../assets/svg/liveclasses/calender.svg?react";
import Quiz from "../../assets/svg/Quiz.svg?react";
import PlayIcon from "../../assets/svg/selflearn/play.svg?react";
import StoriesBackground from "../../assets/svg/selflearn/stories-bg.svg?react";
import ViewIcon from "../../assets/svg/selflearn/view-icon.svg?react";
import TopicSummaryBg from "../../assets/svg/selflearn/topic-summary-bg.svg?react";
import MemoryCardBackground from "../../assets/svg/selflearn/memory-card-bg.svg?react";
import LikeActiveSl from "../../assets/svg/selflearn/liked_active_sl.svg?react";
import LikeInActiveSl from "../../assets/svg/selflearn/liked_inactive_sl.svg?react";
import DisLikeActiveSl from "../../assets/svg/selflearn/disliked_active_sl.svg?react";
import DisLikeInActiveSl from "../../assets/svg/selflearn/disliked_inactive_sl.svg?react";
import BookmarkSl from "../../assets/svg/selflearn/bookmark_sl.svg?react";
import UnBookmarkSl from "../../assets/svg/selflearn/un_bookmark_sl.svg?react";
import NextArrowSl from "../../assets/svg/selflearn/arrow_next_sl.svg?react";
import PreviousArrowSl from "../../assets/svg/selflearn/arrow_prev_sl.svg?react";
import Starprogress1 from "../../assets/svg/selflearn/starprogress1.svg?react";
import Starprogress2 from "../../assets/svg/selflearn/starprogress2.svg?react";
import BotanyStarProgress2 from "../../assets/svg/selflearn/greenstarprogress2.svg?react";
import BotanyStarProgress1 from "../../assets/svg/selflearn/greenstarprogress1.svg?react";
import MathStarProgress1 from "../../assets/svg/selflearn/mathstarprogress1.svg?react";
import MathStarProgress2 from "../../assets/svg/selflearn/mathstarprogress2.svg?react";
import ChemistryStarProgress1 from "../../assets/svg/selflearn/bluestarprogress1.svg?react";
import ChemistryStarProgress2 from "../../assets/svg/selflearn/bluestarprogress2.svg?react";
import EnglishStarProgress1 from "../../assets/svg/selflearn/engstarprogress1.svg?react";
import EnglishStarProgress2 from "../../assets/svg/selflearn/engstarprogress2.svg?react";
import SaveNext from "../../assets/svg/save-next.svg?react";
import Question from "../../assets/svg/question.svg?react";
import DoubleArrowRight from "../../assets/svg/double-arrow-right.svg?react";
import Document from "../../assets/svg/document.svg?react";
import ArrowDownNew from "../../assets/svg/arrowDownNew.svg?react";
import Avatar_boy_04_variant_2 from "../../assets/svg/profileAvatars/Avatar_boy_04_variant_2.svg?react";
import Avatar_boy_07_variant_3_alt from "../../assets/svg/profileAvatars/Avatar_boy_07_variant_3_alt.svg?react";
import Avatar_boy_07_variant_3 from "../../assets/svg/profileAvatars/Avatar_boy_07_variant_3.svg?react";
import Avatar_boy_10_variant_4 from "../../assets/svg/profileAvatars/Avatar_boy_10_variant_4.svg?react";
import Avatar_girl_06_variant_2 from "../../assets/svg/profileAvatars/Avatar_girl_06_variant_2.svg?react";
import Avatar_girl_08_variant_3 from "../../assets/svg/profileAvatars/Avatar_girl_08_variant_3.svg?react";
import Avatar_girl_13_variant_6 from "../../assets/svg/profileAvatars/Avatar_girl_13_variant_6.svg?react";
import Avatar_girl_14_variant_7 from "../../assets/svg/profileAvatars/Avatar_girl_14_variant_7.svg?react";
import Avatar_secondary_01 from "../../assets/svg/profileAvatars/Avatar_secondary_01.svg?react";
import Avatar_secondary_02 from "../../assets/svg/profileAvatars/Avatar_secondary_02.svg?react";
import Avatar_secondary_03 from "../../assets/svg/profileAvatars/Avatar_secondary_03.svg?react";
import Avatar_secondary_04 from "../../assets/svg/profileAvatars/Avatar_secondary_04.svg?react";
import BlueStarIcon from "../../assets/svg/blue-star-icon.svg?react";
import BlueTeacherIcon from "../../assets/svg/blue-teacher-icon.svg?react";
import LevelsTrophy from "../../assets/svg/selflearn/levels_trophy.svg?react";
import ProgressFlag from "../../assets/svg/selflearn/flag.svg?react";
import PracticeTimer from "../../assets/svg/selflearn/practice-timer.svg?react";
import QuitPractice from "../../assets/svg/selflearn/quit-practice.svg?react";
import ChatConversationIcon from "../../assets/svg/chat-conversation-icon.svg?react";
import DeleteIcon from "../../assets/svg/delete.svg?react";
import EmojiVerySad from "../../assets/svg/emoji-very-sad.svg?react";
import EmojiSad from "../../assets/svg/emoji-sad.svg?react";
import EmojiAverage from "../../assets/svg/emoji-average.svg?react";
import EmojiGood from "../../assets/svg/emoji-good.svg?react";
import EmojiVeryGood from "../../assets/svg/emoji-very-good.svg?react";
import ReportWarningIcon from "../../assets/svg/report-warning.svg?react";
import ExerciseIntroIcon from "../../assets/svg/selflearn/execise_icon_intro.svg?react";
import GroupPersionsIcon from "../../assets/svg/selflearn/group_persions.svg?react";
import QuestionListIcon from "../../assets/svg/selflearn/questions_list.svg?react";
import LevelUnlock from "../../assets/svg/selflearn/levelunlock.svg?react";
import PracticeLevel from "../../assets/svg/selflearn/practice_level.svg?react";
import Practicelevel1 from "../../assets/svg/selflearn/level1.svg?react";
import Practicelevel2 from "../../assets/svg/selflearn/level2.svg?react";
import Practicelevel3 from "../../assets/svg/selflearn/level3.svg?react";
import Practicelevel4 from "../../assets/svg/selflearn/level4.svg?react";
import PyqDescription from "../../assets/svg/selflearn/description.svg?react";
import Icpersion from "../../assets/svg/selflearn/ic_persions.svg?react";
import ExerciseIcon from "../../assets/svg/selflearn/exercise-icon.svg?react";
import BulbIcon from "../../assets/svg/selflearn/bulb-icon-sl.svg?react";
import DocsIcon from "../../assets/svg/selflearn/docs-icon.svg?react";
import PdfIcon from "../../assets/svg/selflearn/pdf-icon.svg?react";
import check_circle_outlined from "../../assets/svg/check_circle_outlined.svg?react";
import BiologySubIcon from "../../assets/svg/subjectsicon-without-label/biologysub.svg?react";
import BotanySubIcon from "../../assets/svg/subjectsicon-without-label/botanysub.svg?react";
import BusinessSubIcon from "../../assets/svg/subjectsicon-without-label/businesssub.svg?react";
import CivicsSubIcon from "../../assets/svg/subjectsicon-without-label/civicssub.svg?react";
import CommerceSubIcon from "../../assets/svg/subjectsicon-without-label/commercesub.svg?react";
import ComputerSubIcon from "../../assets/svg/subjectsicon-without-label/computersub.svg?react";
import CriticalThinkSubIcon from "../../assets/svg/subjectsicon-without-label/criticalthinksub.svg?react";
import EconomicsSubIcon from "../../assets/svg/subjectsicon-without-label/economicssub.svg?react";
import ChemistrySubIcon from "../../assets/svg/subjectsicon-without-label/chemistrysub.svg?react";
import EnglishSubIcon from "../../assets/svg/subjectsicon-without-label/englishsub.svg?react";
import EvsSubIcon from "../../assets/svg/subjectsicon-without-label/evssub.svg?react";
import GenericSubIcon from "../../assets/svg/subjectsicon-without-label/genericsub.svg?react";
import GeographySubIcon from "../../assets/svg/subjectsicon-without-label/geographysub.svg?react";
import GkSubIcon from "../../assets/svg/subjectsicon-without-label/gksub.svg?react";
import HindiSubIcon from "../../assets/svg/subjectsicon-without-label/hindisub.svg?react";
import HistorySubIcon from "../../assets/svg/subjectsicon-without-label/historysub.svg?react";
import LogicalSubIcon from "../../assets/svg/subjectsicon-without-label/logicalsub.svg?react";
import MathSubIcon from "../../assets/svg/subjectsicon-without-label/mathsub.svg?react";
import PhysicsSubIcon from "../../assets/svg/subjectsicon-without-label/physicssub.svg?react";
import ProblemSolvingSubIcon from "../../assets/svg/subjectsicon-without-label/problemsolvingsub.svg?react";
import ScienceSubIcon from "../../assets/svg/subjectsicon-without-label/sciencesub.svg?react";
import SocialStudiesSubIcon from "../../assets/svg/subjectsicon-without-label/socialstudiessub.svg?react";
import StatsSubIcon from "../../assets/svg/subjectsicon-without-label/statssub.svg?react";
import VedicMathSubIcon from "../../assets/svg/subjectsicon-without-label/vedicmathsub.svg?react";
import ZoologySubIcon from "../../assets/svg/subjectsicon-without-label/zoologysub.svg?react";
import BiologyLabelIcon from "../../assets/svg/subjecticons-with-labels/biology.svg?react";
import BotanyLabelIcon from "../../assets/svg/subjecticons-with-labels/botany.svg?react";
import BusinessLabelIcon from "../../assets/svg/subjecticons-with-labels/business.svg?react";
import ChemistryLabelIcon from "../../assets/svg/subjecticons-with-labels/chemistry.svg?react";
import CivicsLabelIcon from "../../assets/svg/subjecticons-with-labels/civics.svg?react";
import CommerceLabelIcon from "../../assets/svg/subjecticons-with-labels/commerce.svg?react";
import ComputerScienceLabelIcon from "../../assets/svg/subjecticons-with-labels/computer-science.svg?react";
import CriticalThinkingLabelIcon from "../../assets/svg/subjecticons-with-labels/critical-thinking.svg?react";
import EconomicsLabelIcon from "../../assets/svg/subjecticons-with-labels/economics.svg?react";
import EnglishLabelIcon from "../../assets/svg/subjecticons-with-labels/english.svg?react";
import EvsLabelIcon from "../../assets/svg/subjecticons-with-labels/evs.svg?react";
import GeographyLabelIcon from "../../assets/svg/subjecticons-with-labels/geography.svg?react";
import GkLabelIcon from "../../assets/svg/subjecticons-with-labels/gk.svg?react";
import HindiLabelIcon from "../../assets/svg/subjecticons-with-labels/hindi.svg?react";
import HistoryLabelIcon from "../../assets/svg/subjecticons-with-labels/history.svg?react";
import LogicalLabelIcon from "../../assets/svg/subjecticons-with-labels/logical.svg?react";
import MathsLabelIcon from "../../assets/svg/subjecticons-with-labels/maths.svg?react";
import PhysicsLabelIcon from "../../assets/svg/subjecticons-with-labels/physics.svg?react";
import ProblemSolvingLabelIcon from "../../assets/svg/subjecticons-with-labels/problem-solving.svg?react";
import ScienceLabelIcon from "../../assets/svg/subjecticons-with-labels/science.svg?react";
import SocialStudiesLabelIcon from "../../assets/svg/subjecticons-with-labels/social-studies.svg?react";
import StatsLabelIcon from "../../assets/svg/subjecticons-with-labels/stats.svg?react";
import VedicMathLabelIcon from "../../assets/svg/subjecticons-with-labels/vedic-math.svg?react";
import ZoologyLabelIcon from "../../assets/svg/subjecticons-with-labels/zoology.svg?react";
import LightBulb from "../../assets/svg/selflearn/lightbulb.svg?react";
import Bookmark from "../../assets/svg/bookmark.svg?react";
import Calender from "../../assets/svg/calender.svg?react";
import Filter from "../../assets/svg/filter.svg?react";
import Upload from "../../assets/svg/upload.svg?react";
import scorelogo from "../../assets/svg/scorelogo.svg?react";
import videoIconFilled from "../../assets/svg/selflearn/video-icon-filled.svg?react";
import ReportReattemptIcon from "../../assets/svg/selflearn/report-reattempt-icon.svg?react";
import TalkToExpert from "../../assets/svg/home/talktoexpert.svg?react";
import LevelUpBanner from "../../assets/svg/home/levelup-banner.svg?react";
import LevelUpArrow from "../../assets/svg/home/levelup-arrow.svg?react";
import StopWatch from "../../assets/svg/stopwatch.svg?react";
import EmptyCart from "../../assets/svg/empty-cart.svg?react";
import SelectIcon from "../../assets/svg/selflearn/select_icon.svg?react";
import RepeatIcon from "../../assets/svg/repeatIcon.svg?react";
import Alert from "../../assets/svg/alert.svg?react";
import EditNote from "../../assets/svg/edit-note.svg?react";
import CreateCyotBg from "../../assets/svg/home/create-cyot-bg.svg?react";
import CartIcon from "../../assets/svg/cart.svg?react";
import ExpandMoreThemed from "../../assets/svg/expand_more_themed.svg?react";
import FileUploadIcon from "../../assets/svg/file-upload.svg?react";
import UploadedFileIcon from "../../assets/svg/Uploaded-FileIcon.svg?react";
import PDFUploadIcon from "../../assets/svg/file-upload-pdf.svg?react";
import CircleBulletIcon from "../../assets/svg/circle-bullet.svg?react";
import LevelUpWeb from "../../assets/svg/home/levelup-web.svg?react";
import ChatCloseIcon from "../../assets/svg/chat-close-icon.svg?react";
import ChatIconButton from "../../assets/svg/chat-icon-button.svg?react";
import TickCircledIcon from "../../assets/svg/tick-circled-active.svg?react";
import CrossedRedBackground from "../../assets/svg/crossed-red-background.svg?react";
import CircleListIcon from "../../assets/svg/circle_icon.svg?react";
import UploadFileIcon from "../../assets/svg/upload_file.svg?react";
import CircleWithBorder from "../../assets/svg/circle-with-border.svg?react";
import ErrorOutlineIcon from "../../assets/svg/error_outline.svg?react";
import CheckCircleIcon from "../../assets/svg/check_circle.svg?react";
import CancelOutline from "../../assets/svg/cancel-outline.svg?react";
import ArrowDropDown from "../../assets/svg/arrowDropDown.svg?react";
import QueryBuilder from "../../assets/svg/query_builder.svg?react";
import ChallengeWindow from "../../assets/svg/challenge_window.svg?react";
import PhotoCamera from "../../assets/svg/photo_camera.svg?react";
import FileUpload from "../../assets/svg/file_upload.svg?react";
import SupportAgentIcon from "../../assets/svg/support_agent.svg?react";
import SuccessIllustration from "../../assets/svg/Illustration.svg?react";
import TimerLoad from "../../assets/svg/timer_load.svg?react";
import Save from "../../assets/svg/save.svg?react";
import HourGlassBottom from "../../assets/svg/hourglass_bottom.svg?react";
import DoubtExhaustLock from "../../assets/svg/lock.svg?react";
import DoubtExhaustLockAskIcon from "../../assets/svg/lock-Doubt.svg?react";
import bookListIcon from "../../assets/svg/selflearn/booklist-icon.svg?react";
import TrophyIcon from "../../assets/svg/trophy_icon.svg?react";
import SwipeLeftIcon from "../../assets/svg/swipe_left_icon.svg?react";
import SwipeRightIcon from "../../assets/svg/swipe_right_icon.svg?react";
import CardOfTheDayBackGround from "../../assets/svg/card_of_day_background.svg?react";
import CardOfTheDayBackForWeb from "../../assets/svg/card_of_the_day_back_for_web.svg?react";
import InvCloseIcon from "../../assets/svg/inv-close-icon.svg";
import SearchIcon from "../../assets/svg/search-icon.svg";
import NotFound from "../../assets/svg/not-found.svg";
import CheckCircleFilled from "../../assets/svg/check-circle-filled.svg?react";
import BookmarkFlashcardIcon from "../../assets/svg/selflearn/bookmark_flashcard_ic.svg?react";
import BookmarkMemoryCardIcon from "../../assets/svg/selflearn/bookmark_memorycard_ic.svg?react";
import BookmarkRightArrow from "../../assets/svg/selflearn/bookmark_right_arrow.svg?react";
import Cancel from "../../assets/svg/cancel.svg?react";
import CircleBullet from "../../assets/svg/circle_bullet.svg?react";

import ShareIconReferrals from "../../assets/svg/share-icon-referrals.svg?react";
import ContentCopyReferral from "../../assets/svg/content-copy-referral.svg?react";

import BenchmarkLowest from "../../assets/svg/benchmark-lowest.svg?react";
import BenchmarkHighest from "../../assets/svg/benchmark-highest.svg?react";
import ToDoTest from "../../assets/svg/todo-test.svg?react";
import ToDoAssignment from "../../assets/svg/todo-assignment.svg?react";
import AinaWidgetIcon from "../../assets/svg/aina-widget-icon.svg?react";
import FlashOn from "../../assets/svg/flash-on.svg?react";
import Alarm from "../../assets/svg/alarm.svg?react";
import Study from "../../assets/svg/Study.svg?react";
import StepsDoubtIcon from "../../assets/svg/extension.svg?react";
import HintsDoubtIcon from "../../assets/svg/tips_and_updates.svg?react";
import SolutionDoubtIcon from "../../assets/svg/solution-doubt.svg?react";
import GirlSearching from "../../assets/svg/girl-searching.svg?react";
import GuyTimer from "../../assets/svg/guy-timer.svg?react";
import PhotoIcon from "../../assets/svg/photo-icon.svg?react";
import StoriesIcon from "../../assets/svg/selflearn/sl-story-ic.svg?react";
import QuitIcon from "../../assets/svg/selflearn/quitCloseIcon.svg?react";
import WhatsAppIcon from "../../assets/svg/whatsappIcon.svg?react";
import CalenderMonth from "../../assets/svg/calendar-month.svg?react";
import EyeShortsIcon from "../../assets/svg/eye_shorts.svg?react";
import Mail from "../../assets/svg/mail.svg?react";
import WhatsAppLogin from "../../assets/svg/whatsapp-login.svg?react";
import CheckboxBlue from "../../assets/svg/checkbox-blue.svg?react";
import ic_evs_sub_Icon from "../../assets/svg/ic_evs_sub_Icon.svg?react";
import ArrowDropdownDoubts from "../../assets/svg/arrow_dropdown_doubts.svg?react";
import FileDownload from "../../assets/svg/file_download.svg?react";
import GenericSubjectToDoIcon from "../../assets/svg/home/GenericSubjectToDoIcon.svg?react";
import AinaDoubtIcon from "../../assets/svg/Aina_doubt.svg?react";
import longArrow from "../../assets/svg/longArrow.svg?react";
import eyyOff from "../../assets/svg/eye-off.svg?react";
import ErrorOutlineMaroon from "../../assets/svg/error_outline_maroon.svg?react";
import ExpandMoreBookmark from "../../assets/svg/selflearn/expand_more_bookmark.svg?react";
import OfflineClass from "../../assets/svg/liveclasses/OfflineClass.svg?react";
import OnlineClass from "../../assets/svg/liveclasses/OnlineClass.svg?react";

export const iconsMap = {
  whatsappIcon2: WhatsAppIcon,
  whatsappLogin: WhatsAppLogin,
  fileDownload: FileDownload,
  checkboxBlue: CheckboxBlue,
  delete: DeleteIcon,
  blueStarIcon: BlueStarIcon,
  blueTeacherIcon: BlueTeacherIcon,
  chatIcon: ChatIcon,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  visibilityOn: VisibilityOnIcon,
  info: Info,
  LiveClassIcon: LiveClassIcon,
  AssignmentsIcon: AssignmentsIcon,
  repeat: Repeat,
  videoCamera: VideoCamera,
  Camera: Camera,
  ellipseRight: EllipseRight,
  circle: Circle,
  arrowBackIcon: ArrowBackIcon,
  menu: Menu,
  userProfileIcon: UserProfileIcon,
  botanyPlant: BotanyPlant,
  chemFlask: ChemFlask,
  phyBulb: PhyBulb,
  stepsDoubtIcon: StepsDoubtIcon,
  hintsDoubtIcon: HintsDoubtIcon,
  solutionDoubtIcon: SolutionDoubtIcon,
  iconVideoplay: IconVideoplay,
  zoology: Zoology,
  engBoxes: EngBoxes,
  match: Match,
  check: Check,
  thumbUp: ThumbUp,
  thumbDown: ThumbDown,
  selectedThumbUp: SelectedThumbUp,
  selectedThumbDown: SelectedThumbDown,
  report: Report,
  rewatchVideo: RewatchVideo,
  sessionsAttended: SessionsAttended,
  clockIcon: ClockIcon,
  notepadIcon: NotepadIcon,
  physicsSubjectIcon: PhysicsSubjectIcon,
  calendarIcon: calendarIcon,
  calendar: calendar,
  noDataIcon: NoDataIcon,
  gradeIcon: GradeIcon,
  courseIcon: CourseIcon,
  arrowForwardIcon: ArrowForwardIcon,
  closeIcon: CloseIcon,
  closeButton: CloseButton,
  filterIcon: FilterIcon,
  logoWhite: LogoWhite,
  containerLeftFilled: ContainerLeftFilled,
  containerRightFilled: ContainerRightFilled,
  arrowBack: ArrowBack,
  checkedIcon: CheckedIcon,
  indeterminateIcon: IndeterminateIcon,
  close: Close,
  arrowRight: ArrowRight,
  ainaArrowCta: AinaArrowCta,
  arrowBackIos: ArrowBackIos,
  radioButtonUnchecked: RadioButtonUnchecked,
  radioButtonChecked: RadioButtonChecked,
  checkbox: Checkbox,
  checkboxChecked: CheckboxChecked,
  checkboxMinus: CheckboxMinus,
  phoneIcon: PhoneIcon,
  personIcon: PersonIcon,
  admissionIcon: AdmissionIcon,
  arrowForward: ArrowForward,
  Home: Home,
  homeIcon: HomeIcon,
  ilLogoIcon: ILLogoIcon,
  ilLogoIconWhite: ILLogoIconWhite,
  windowIcon: WindowIcon,
  moreDotsIcon: MoreDotsIcon,
  HomeIcon: HomeIcon,
  LearnIcon: LearnIcon,
  TestsIcon: TestsIcon,
  DoubtsIcon: DoubtsIcon,
  BookmarksIcon: BookmarksIcon,
  SubscriptionsIcon: SubscriptionsIcon,
  ReferEarnIcon: ReferEarnIcon,
  ContactUsIcon: ContactUsIcon,
  LogOutIcon: LogOutIcon,
  LiveClassesIcon: LiveClassesIcon,
  PeopleIcon: PeopleIcon,
  live_Classes: live_Classes,
  learn: learn,
  tests: tests,
  Doubts: Doubts,
  bookmarks: bookmarks,
  bookmarkIconDoubts: BookmarkIconDoubts,
  selected_bookmark: SelectedBookmark,
  Subscriptions: Subscriptions,
  ReferEarn: ReferEarn,
  contact_us: contact_us,
  log_out: log_out,
  expandMore: ExpandMore,
  expandMoreThemed: ExpandMoreThemed,
  keyBoardArrowDown: KeyBoardArrowDown,
  keyBoardArrowUp: KeyBoardArrowUp,
  edit: Edit,
  sms: Sms,
  whatsapp: Whatsapp,
  ilLogo: IlLogo,
  il_logo: IL_logo,
  meta: Meta,
  sca: Sca,
  chemistryClass: ChemistryClass,
  physicsClass: PhysicsClass,
  mathsClass: MathsClass,
  englishClass: EnglishClass,
  botanyClass: BotanyClass,
  biologyClass: BiologyClass,
  zoologyClass: ZoologyClass,
  infoIcon: InfoIcon,
  rewatchIcon: RewatchIcon,
  timeIcon: TimeIcon,
  vectorIcon: VectorIcon,
  secondaryIcon: SecondaryIcon,
  filterAltIcon: FilterAltIcon,
  icTrBack: IcTrBack,
  circleIcon: CircleIcon,
  botany: Botany,
  chemistrySubjectIcon: ChemistrySubjectIcon,
  mathSubjectIcon: MathSubjectIcon,
  zoologySubjectIcon: ZoologySubjectIcon,
  botanySubjectIcon: BotanySubjectIcon,
  englishSubjectIcon: EnglishSubjectIcon,
  biologySubjectIcon: BiologySubjectIcon,
  illustration: Illustration,
  ilLogo1: IlLogo1,
  ellipse995: Ellipse995,
  visibilityDark: VisibilityDark,
  male: Male,
  female: Female,
  add: Add,
  resetPassword: ResetPassword,
  redirect: Redirect,
  checkmarkIcon: CheckmarkIcon,
  headerMenu: HeaderMenu,
  vector: Vector,
  infoGreen: InfoGreen,
  resumeLearningLeftArrow: ResumeLearningLeftArrow,
  resumeLearningVideoIcon: ResumeLearningVideoIcon,
  resumeLearningFlashcardIcon: ResumeLearningFlashcardIcon,
  resumeLearningPracticeIcon: ResumeLearningPracticeIcon,
  marketingPageIcon: MarketingPageIcon,
  sessionDetailsIcon: SessionDetailsIcon,
  sessionDetailsIconBlack: SessionDetailsIconBlack,
  reportIssueIcon: ReportIssueIcon,
  reportIssueIconBlack: ReportIssueIconBlack,
  expandIcon: ExpandIcon,
  chatCloseIcon: ChatCloseIcon,
  chatIconButton: ChatIconButton,
  successIllustration: SuccessIllustration,
  icBioSubIcon: IcBioSubIcon,
  ic_botany_sub_icon: IcBotanySubIcon,
  icChemSubIcon: IcChemSubIcon,
  ic_computer_science_sub_icon: IcComputerScienceSubIcon,
  ic_critical_thinking_sub_icon: IcCriticalThinkingSubIcon,
  ic_default_sub_icon: IcDefaultSubIcon,
  icEngSubIcon: IcEngSubIcon,
  ic_english_sub_icon: IcEnglishSubIcon,
  ic_gk_sub_icon: IcGkSubIcon,
  ic_hindi_sub_icon: IcHindiSubIcon,
  ic_history_sub_icon: IcHistorySubIcon,
  ic_logical_sub_icon: IcLogicalSubIcon,
  icMathSubIcon: IcMathSubIcon,
  icPhySubIcon: IcPhySubIcon,
  ic_probleam_solving_sub_icon: IcProbleamSolvingSubIcon,
  ic_problem_solving_sub_icon: IcProbleamSolvingSubIcon,
  ic_science_sub_icon: IcScienceSubIcon,
  ic_socal_study_sub_icon: IcSocalStudySubIcon,
  ic_social_study_sub_icon: IcSocalStudySubIcon,
  ic_subject_business: IcSubjectBusiness,
  ic_subject_commerce: IcSubjectCommerce,
  ic_subject_comnomics: IcSubjectComnomics,
  ic_subject_civic_sub: IcSubjectCivicSub,
  ic_subject_geography_sub: IcSubjectGeographySub,
  ic_subject_state: IcSubjectState,
  ic_vedic_match_sub_icon: IcVedicMatchSubIcon,
  icZooSubIcon: IcZooSubIcon,
  bookOutline: BookOutline,
  circleBackBtn: CircleBackBtn,
  selflearnConfirmationIcon: selflearnConfirmationIcon,
  winCup: winCup,
  trialExpired: trialExpired,
  cardGiftcard: cardGiftcard,
  contentCopy: contentCopy,
  book: Book,
  clock: Clock,
  ilCardLogo: IL_CardLogo,
  arrowUp: ArrowUp,
  arrowDown: ArrowDown,
  infoColor: InfoColor,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  bookCover: bookCover,
  chemistryMainIcon: chemistryMainIcon,
  chemistryDecor1Icon: chemistryDecor1Icon,
  chemistryDecor2Icon: chemistryDecor2Icon,
  mathsMainIcon: mathsMainIcon,
  mathsDecor1Icon: mathsDecor1Icon,
  mathsDecor2Icon: mathsDecor2Icon,
  physicsMainIcon: physicsMainIcon,
  physicsDecor1Icon: physicsDecor1Icon,
  physicsDecor2Icon: physicsDecor2Icon,
  englishMainIcon: englishMainIcon,
  englishDecor1Icon: englishDecor1Icon,
  englishDecor2Icon: englishDecor2Icon,
  zoologyMainIcon: zoologyMainIcon,
  zoologyDecor1Icon: zoologyDecor1Icon,
  zoologyDecor2Icon: zoologyDecor2Icon,
  botanyMainIcon: botanyMainIcon,
  botanyDecor1Icon: botanyDecor1Icon,
  botanyDecor2Icon: botanyDecor2Icon,
  biologyMainIcon: biologyMainIcon,
  civicsMainIcon: civicsMainIcon,
  commerceMainIcon: commerceMainIcon,
  computerMainIcon: computerMainIcon,
  criticalThinkingMainIcon: criticalThinkingMainIcon,
  economicsMainIcon: economicsMainIcon,
  evsMainIcon: evsMainIcon,
  geographyMainIcon: geographyMainIcon,
  gkMainIcon: gkMainIcon,
  hindiMainIcon: hindiMainIcon,
  historyMainIcon: historyMainIcon,
  logicalMainIcon: logicalMainIcon,
  physicsMain2Icon: physicsMain2Icon,
  problemSolvingMainIcon: problemSolvingMainIcon,
  scienceMainIcon: scienceMainIcon,
  socialMainIcon: socialMainIcon,
  statsMainIcon: statsMainIcon,
  vedicMatchMainIcon: vedicMatchMainIcon,
  businessMainIcon: businessMainIcon,
  genericMainIcon: genericMainIcon,
  biologyFilledIcon: biologyFilledIcon,
  botanyFilledIcon: botanyFilledIcon,
  businessFilledIcon: businessFilledIcon,
  chemistryFilledIcon: chemistryFilledIcon,
  civicsFilledIcon: civicsFilledIcon,
  commerceFilledIcon: commerceFilledIcon,
  computerFilledIcon: computerFilledIcon,
  criticalThinkingFilledIcon: criticalThinkingFilledIcon,
  economicsFilledIcon: economicsFilledIcon,
  englishFilledIcon: englishFilledIcon,
  evsFilledIcon: evsFilledIcon,
  genericFilledIcon: genericFilledIcon,
  geographyFilledIcon: geographyFilledIcon,
  gkFilledIcon: gkFilledIcon,
  hindiFilledIcon: hindiFilledIcon,
  historyFilledIcon: historyFilledIcon,
  logicalFilledIcon: logicalFilledIcon,
  mathFilledIcon: mathFilledIcon,
  physicsFilledIcon: physicsFilledIcon,
  problemSolvingFilledIcon: problemSolvingFilledIcon,
  scienceFilledIcon: scienceFilledIcon,
  socialFilledIcon: socialFilledIcon,
  statsFilledIcon: statsFilledIcon,
  vedicMatchFilledIcon: vedicMatchFilledIcon,
  zoologyFilledIcon: zoologyFilledIcon,
  blueWhiteDot: BlueWhiteDot,
  blueVector: BlueVector,
  whiteDot: WhiteDot,
  studentWithLaptop: StudentWithLaptop,
  shareIcon: ShareIcon,
  shareFilledIcon: ShareFilledIcon,
  shareNotFilledIcon: ShareNotFilledIcon,
  openBookIcon: OpenBookIcon,
  copyIcon: CopyIcon,
  whiteArrowDown: WhiteArrowDown,
  cyotarrow: CyotArrow,
  scaCardLogo: SCA_CardLogo,
  editFilled: editFilled,
  card: card,
  media: media,
  buttonTonal: buttonTonal,
  ArrRight: ArrRight,
  t1: t1,
  content: content,
  eye: eye,
  subscriptionLock: SubscriptionLockIcon,
  couponGift: CouponGift,
  ic_arrow_up: IcArrowUp,
  ic_arrow_down: IcArrowDown,
  shortsScrollUp: ScrollUpShorts,
  shortsScrollDown: ScrollDownShorts,
  shortsArrowBack: ArrowBackShorts,
  footprints: Footprints,
  toffee: Toffee,
  chemistry: Chemistry,
  arrowuptest: ArrowUpTest,
  forwardArrow: ForwardArrow,
  backwardArrow: BackwardArrow,
  about: About,
  flag: Flag,
  error: RedTriangleWithWhiteExclamation,
  textView: TextView,
  gridView: GridView,
  videoIcon: videoIcon,
  backIcon: BackIcon,
  fullScreenIcon: FullScreenIcon,
  fullScreenExitIcon: FullScreenExitIcon,
  collapseArrow: CollapseArrow,
  rightArrowIcon: RightArrowIcon,
  bookmarkTestImg: BookmarkTestImg,
  bookmarkCardImg: BookmarkCardImg,
  bookmarkTopicSummaryImg: BookmarkTopicSummaryImg,
  bookmarkNotFoundImg: BookmarkNotFoundImg,
  bookmarkCheckedMinus: BookmarkCheckedMinus,
  bookmarkCheck: BookmarkCheck,
  bookmarkUnchecked: BookmarkUnchecked,
  threeDotIcon: ThreeDotIcon,
  homeOutline: HomeOutline,
  homeFilled: HomeFilled,
  playFilled: PlayFilled,
  playOutline: PlayOutline,
  bookFilled: BookFilled,
  todoIcon: TodoIcon,
  timer: Timer,
  practiceTimer: PracticeTimer,
  interactiveDefaultIcon: InteractiveDefaultIcon,
  interactivePlayIcon: InteractivePlayIcon,
  interactiveIllustration: InteractiveIllustration,
  liveClassesCalender: LiveClassesCalender,
  quiz: Quiz,
  playIcon: PlayIcon,
  storiesBackground: StoriesBackground,
  viewIcon: ViewIcon,
  topicSummaryBg: TopicSummaryBg,
  memoryCardBackground: MemoryCardBackground,
  likeActiveSl: LikeActiveSl,
  likeInActiveSl: LikeInActiveSl,
  disLikeActiveSl: DisLikeActiveSl,
  disLikeInActiveSl: DisLikeInActiveSl,
  bookmarkSl: BookmarkSl,
  unBookmarkSl: UnBookmarkSl,
  nextArrowSl: NextArrowSl,
  previousArrowSl: PreviousArrowSl,
  starprogress1: Starprogress1,
  starprogress2: Starprogress2,
  botanyStarProgress1: BotanyStarProgress1,
  botanyStarProgress2: BotanyStarProgress2,
  mathStarProgress1: MathStarProgress1,
  mathStarProgress2: MathStarProgress2,
  chemistryStarProgress1: ChemistryStarProgress1,
  chemistryStarProgress2: ChemistryStarProgress2,
  englishStarProgress1: EnglishStarProgress1,
  englishStarProgress2: EnglishStarProgress2,
  question: Question,
  saveNext: SaveNext,
  bookmarkFilled: BookmarkFilled,
  exerciseIntroIcon: ExerciseIntroIcon,
  lockIcon: LockIcon,
  linkedinIcon: LinkedInIcon,
  emailIcon: EmailIcon,
  facebookIcon: FacebookIcon,
  xIcon: XIcon,
  trapezoid: Trapezoid,
  trapezoidOutline: TrapezoidOutline,
  currTrapezoid: CurrTrapezoid,
  doubleArrowRight: DoubleArrowRight,
  document: Document,
  funnel: Funnel,
  arrowDownNew: ArrowDownNew,
  stopCircle: StopCircleIcon,
  levelsTrophy: LevelsTrophy,
  progressFlag: ProgressFlag,
  quitPractice: QuitPractice,
  avatar_boy_04_variant_2: Avatar_boy_04_variant_2,
  avatar_boy_07_variant_3_alt: Avatar_boy_07_variant_3_alt,
  avatar_boy_07_variant_3: Avatar_boy_07_variant_3,
  avatar_boy_10_variant_4: Avatar_boy_10_variant_4,
  avatar_girl_06_variant_2: Avatar_girl_06_variant_2,
  avatar_girl_08_variant_3: Avatar_girl_08_variant_3,
  avatar_girl_13_variant_6: Avatar_girl_13_variant_6,
  avatar_girl_14_variant_7: Avatar_girl_14_variant_7,
  avatar_secondary_01: Avatar_secondary_01,
  avatar_secondary_02: Avatar_secondary_02,
  avatar_secondary_03: Avatar_secondary_03,
  avatar_secondary_04: Avatar_secondary_04,
  chatConversationIcon: ChatConversationIcon,
  emojiVerySad: EmojiVerySad,
  emojiSad: EmojiSad,
  emojiAverage: EmojiAverage,
  emojiGood: EmojiGood,
  reportWarningIcon: ReportWarningIcon,
  emojiVeryGood: EmojiVeryGood,
  groupPersionsicon: GroupPersionsIcon,
  questionListIcon: QuestionListIcon,
  levelUnlock: LevelUnlock,
  practiceLevel: PracticeLevel,
  practicelevel1: Practicelevel1,
  practicelevel2: Practicelevel2,
  practicelevel3: Practicelevel3,
  practicelevel4: Practicelevel4,
  pyqDescription: PyqDescription,
  icPersion: Icpersion,
  exerciseIcon: ExerciseIcon,
  bulbIcon: BulbIcon,
  checkCircleOutlined: check_circle_outlined,
  lightBulb: LightBulb,
  docsIcon: DocsIcon,
  pdfIcon: PdfIcon,
  biologySubIcon: BiologySubIcon,
  botanySubIcon: BotanySubIcon,
  businessSubIcon: BusinessSubIcon,
  civicsSubIcon: CivicsSubIcon,
  commerceSubIcon: CommerceSubIcon,
  computerSubIcon: ComputerSubIcon,
  criticalThinkSubIcon: CriticalThinkSubIcon,
  economicsSubIcon: EconomicsSubIcon,
  chemistrySubIcon: ChemistrySubIcon,
  englishSubIcon: EnglishSubIcon,
  evsSubIcon: EvsSubIcon,
  genericSubIcon: GenericSubIcon,
  geographySubIcon: GeographySubIcon,
  gkSubIcon: GkSubIcon,
  hindiSubIcon: HindiSubIcon,
  historySubIcon: HistorySubIcon,
  logicalSubIcon: LogicalSubIcon,
  mathSubIcon: MathSubIcon,
  physicsSubIcon: PhysicsSubIcon,
  problemSolvingSubIcon: ProblemSolvingSubIcon,
  scienceSubIcon: ScienceSubIcon,
  socialStudiesSubIcon: SocialStudiesSubIcon,
  statsSubIcon: StatsSubIcon,
  vedicMathSubIcon: VedicMathSubIcon,
  zoologySubIcon: ZoologySubIcon,
  biologyLabelIcon: BiologyLabelIcon,
  botanyLabelIcon: BotanyLabelIcon,
  businessLabelIcon: BusinessLabelIcon,
  chemistryLabelIcon: ChemistryLabelIcon,
  civicsLabelIcon: CivicsLabelIcon,
  commerceLabelIcon: CommerceLabelIcon,
  computerScienceLabelIcon: ComputerScienceLabelIcon,
  criticalThinkingLabelIcon: CriticalThinkingLabelIcon,
  economicsLabelIcon: EconomicsLabelIcon,
  englishLabelIcon: EnglishLabelIcon,
  evsLabelIcon: EvsLabelIcon,
  geographyLabelIcon: GeographyLabelIcon,
  gkLabelIcon: GkLabelIcon,
  hindiLabelIcon: HindiLabelIcon,
  historyLabelIcon: HistoryLabelIcon,
  logicalLabelIcon: LogicalLabelIcon,
  mathsLabelIcon: MathsLabelIcon,
  physicsLabelIcon: PhysicsLabelIcon,
  problemSolvingLabelIcon: ProblemSolvingLabelIcon,
  scienceLabelIcon: ScienceLabelIcon,
  socialStudiesLabelIcon: SocialStudiesLabelIcon,
  statsLabelIcon: StatsLabelIcon,
  vedicMathLabelIcon: VedicMathLabelIcon,
  zoologyLabelIcon: ZoologyLabelIcon,
  benchmarkLowest: BenchmarkLowest,
  benchmarkHighest: BenchmarkHighest,
  Bookmark: Bookmark,
  Calender: Calender,
  Filter: Filter,
  upload: Upload,
  scorelogo: scorelogo,
  videoiconFilled: videoIconFilled,
  reportReattemptIcon: ReportReattemptIcon,
  talkToExpert: TalkToExpert,
  levelUpBanner: LevelUpBanner,
  levelUpArrow: LevelUpArrow,
  stopwatch: StopWatch,
  emptyCart: EmptyCart,
  editNote: EditNote,
  selectIcon: SelectIcon,
  repeatIcon: RepeatIcon,
  alert: Alert,
  createCyotBg: CreateCyotBg,
  cartIcon: CartIcon,
  fileUploadIcon: FileUploadIcon,
  uploadedFileIcon: UploadedFileIcon,
  pdfUploadIcon: PDFUploadIcon,
  circleBulletIcon: CircleBulletIcon,
  levelUpWeb: LevelUpWeb,
  tickCircledIcon: TickCircledIcon,
  crossedRedBackground: CrossedRedBackground,
  circleListIcon: CircleListIcon,
  uploadFileIcon: UploadFileIcon,
  circleWithBorder: CircleWithBorder,
  errorOutlineIcon: ErrorOutlineIcon,
  checkCircleIcon: CheckCircleIcon,
  cancelOutline: CancelOutline,
  arrowDropDown: ArrowDropDown,
  queryBuilder: QueryBuilder,
  challengeWindow: ChallengeWindow,
  photoCamera: PhotoCamera,
  fileUpload: FileUpload,
  supportAgent: SupportAgentIcon,
  timerLoad: TimerLoad,
  save: Save,
  hourGlassBottom: HourGlassBottom,
  doubtExhaustLockIcon: DoubtExhaustLock,
  doubtExhaustLockAskIcon: DoubtExhaustLockAskIcon,
  bookListIcon: bookListIcon,
  trophyIcon: TrophyIcon,
  swipeLeftIcon: SwipeLeftIcon,
  swipeRightIcon: SwipeRightIcon,
  cardOfTheDayBackGround: CardOfTheDayBackGround,
  cardOfTheDayBackForWeb: CardOfTheDayBackForWeb,
  invCloseIcon: InvCloseIcon,
  searchIcon: SearchIcon,
  notFound: NotFound,
  checkCircleFilled: CheckCircleFilled,
  bookmarkFlashcardIcon: BookmarkFlashcardIcon,
  bookmarkMemoryCardIcon: BookmarkMemoryCardIcon,
  bookmarkRightArrow: BookmarkRightArrow,
  cancel: Cancel,
  circleBullet: CircleBullet,
  shareIconReferrals: ShareIconReferrals,
  contentCopyReferral: ContentCopyReferral,
  todoTest: ToDoTest,
  todoAssignment: ToDoAssignment,
  ainaWidgetIcon: AinaWidgetIcon,
  flashOn: FlashOn,
  alarm: Alarm,
  study: Study,
  guyTimer: GuyTimer,
  girlSearching: GirlSearching,
  photoIcon: PhotoIcon,
  storiesIcon: StoriesIcon,
  quitIcon: QuitIcon,
  calenderMonth: CalenderMonth,
  eyeShorts: EyeShortsIcon,
  mail: Mail,
  ic_evs_sub_Icon: ic_evs_sub_Icon,
  arrowDropdownDoubts: ArrowDropdownDoubts,
  genericSubjectToDoIcon: GenericSubjectToDoIcon,
  ainaDoubtIcon: AinaDoubtIcon,
  longArrow: longArrow,
  eyyOff: eyyOff,
  errorOutlineMaroon: ErrorOutlineMaroon,
  expandMoreBookmark: ExpandMoreBookmark,
  offlineClass: OfflineClass,
  onlineClass: OnlineClass,
};

export type IconName = keyof typeof iconsMap;
